import { Component, OnDestroy, Renderer2 } from '@angular/core';
import { ImageGroup } from '@spartacus/core';
import { ProductImageZoomProductImagesComponent } from '@spartacus/product/image-zoom/components';
import { BREAKPOINT, BreakpointService, CurrentProductService } from '@spartacus/storefront';
import { BehaviorSubject, Observable, Subscription, forkJoin } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'cx-product-images',
  templateUrl: './custom-product-images.component.html',
  styleUrls: ['./custom-product-images.component.scss'],
  standalone: false
})
export class CustomProductImagesComponent extends ProductImageZoomProductImagesComponent implements OnDestroy {
  protected subscriptions: Subscription = new Subscription();
  protected renderer: Renderer2;
  animation = 'swipe';
  slideSize = '120px';
  expandImage = new BehaviorSubject(false)

  thumbnails = [];

  xDown = null;
  xDiff = null;
  isDown = false;
  zoomActive = false;

  constructor(
    //@Inject(DOCUMENT) protected  document: any,
    //protected renderFactory: RendererFactory2,
    private currentProductServices: CurrentProductService,
    protected breakpointService: BreakpointService
  ) {
    super(currentProductServices);
    //this.renderer = renderFactory.createRenderer(null, null);
    this.subscriptions.add(this.thumbs$.pipe(
      switchMap((data) => forkJoin(data))
    ).subscribe((data) => {
      this.thumbnails = data;
    }));
  }

  isMobile(): Observable<boolean> {
    return this.breakpointService?.isDown(BREAKPOINT.md);
  }

  clickStart(value: boolean): void {
    //this.renderer.addClass(this.document.body, 'modal-open')
    //this.zoomActive = true;
    this.expandImage.next(value)
  }

  touchMove(event: TouchEvent, activeSlide: any): void {
    if (!this.xDown) {
      return;
    }

    const touch = event.touches[0] || event.changedTouches[0];

    const xUp = touch.clientX;
    this.xDiff = this.xDown - xUp;

    if (Math.abs(this.xDiff) !== 0) {
      if (this.xDiff > 2) {
        const image = this.getNextImage(activeSlide);
        this.openImage(image.container);
      } else if (this.xDiff < -2) {
        const image = this.getPreviousImage(activeSlide);
        this.openImage(image.container);
      }
    }

    // Reset values.
    this.xDown = null;
  }

  getActiveIndex(container: any): number {
    const current = this.thumbnails.find(
      (t) =>
        container.zoom &&
        t.container &&
        t.container.zoom &&
        t.container.zoom.url === container.zoom.url
    );
    return this.thumbnails.indexOf(current);
  }

  getPreviousImage(activeSlide: any): ImageGroup {
    const active = this.getActiveIndex(activeSlide);
    if (active === 0) {
      return this.thumbnails[active];
    }
    return this.thumbnails[active - 1];
  }

  getNextImage(activeSlide: any): ImageGroup {
    const active = this.getActiveIndex(activeSlide);
    if (active === this.thumbnails.length - 1) {
      return this.thumbnails[active];
    }
    return this.thumbnails[active + 1];
  }


  mouseDownSlide(event: MouseEvent): boolean {
    this.isDown = true;

    this.xDown = event.clientX;

    return false;
  }

  mouseUpSlide(event: MouseEvent, activeSlide: any): void {
    const x = event.clientX - this.xDown;

    if (x > 0) {
      const image = this.getPreviousImage(activeSlide);
      this.openImage(image.container);
    } else if (x < 0) {
      const image = this.getNextImage(activeSlide);
      this.openImage(image.container);
    }

    this.isDown = false;
    this.xDown = null;
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
